<template>
  <form class="form">
    <div class="form__head">
      <div class="form__title form__title_white mb10">
        Updateinformation
        <button type="reset" class="close-btn" @click="$emit('close')">
          <img src="@/assets/images/close.svg" width="24px" alt />
        </button>
      </div>
    </div>

    <div class="form__content">
      <div class="form-item mb12">
        <div>
          <p>{{ $t("forms.whoWillAccpetMaster") }}</p>
        </div>
      </div>

      <div class="form-item form-item_flex form-item_between mb24 flex-pub-m-column">
        <div class="form-item_half mb24_m">
          <el-input
            class="form-item__first-name"
            :placeholder="$t('forms.firstName')"
            v-model="form.contact.first_name"
          />
        </div>

        <div class="form-item_half">
          <el-input :placeholder="$t('forms.lastName')" v-model="form.contact.last_name" />
        </div>
      </div>

      <div class="form-item form-item_flex form-item_between mb24 flex-pub-m-column">
        <div class="form-item_half mb24_m">
          <el-input
            :placeholder="$t('forms.email')"
            class="disabled-input"
            disabled
            v-model="form.contact.email"
          />
        </div>

        <div class="form-item_half">
          <vue-tel-input
            v-model="form.contact.phone"
            @validate="checkValue"
            :placeholder="$t('forms.phone')"
            :inputOptions="{ showDialCode: true }"
            mode="international"
          ></vue-tel-input>
        </div>
      </div>

      <div class="mb24 line"></div>

      <div class="form-item form-item_flex form-item_between mb24 flex-pub-m-column">
        <div class="form-item_half mb24_m">
          <el-date-picker
            v-model="form.date"
            type="date"
            :placeholder="$t('forms.pickADay')"
            format="dd/MM/yyyy"
            @change="changeTime"
            :pickerOptions="pickerOptions"
            :editable="false"
          ></el-date-picker>
        </div>

        <div class="form-item_half">
          <el-select v-model="form.time" :placeholder="$t('forms.chooseTime')">
            <el-option v-for="item in timeOptions.current" :key="item.id" :value="item.time">
              <span>
                {{ item.time }}
                <span style="font-weight: bold; margin-left: 8px;">
                  {{
                  getPrice(item)
                  }}
                </span>
              </span>
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="form-item">
        <button
          :disabled="!isValid || isSubmitted"
          :class="{
            btn_disabled: !isValid || isSubmitted,
          }"
          class="btn btn_width btn_mobile-width-100"
          type="reset"
          @click="onSave"
        >{{ $t("buttons.save") }}</button>
      </div>

      <div class="form-item mt60" v-if="canCancel">
        <button
          type="reset"
          @click="toggleDeleteModal"
          class="btn btn_cancel"
          :class=" {
                            'btn_cancel-disable': isCanceled
                        }"
          :disabled="isCanceled"
        >{{$t("forms.cancelText")}}</button>
      </div>
    </div>

    <main-modal :show="showDeleteModal" :className="'delete-modal'" @close="toggleDeleteModal">
      <delete-modal @close="toggleDeleteModal" @accept="cancel" />
    </main-modal>
  </form>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import {
  required,
  requiredIf,
  minLength,
  sameAs
} from "vuelidate/lib/validators";
import checkEmail from "@/helpers/utils/emailCheck";
import mainModal from "@/components/modals/mainModal";
import deleteModal from "@/components/modals/delete/index";

export default {
  name: "edit-order-info",
  props: {
    contact: {
      required: true
    },
    id: {
      required: true
    },
    date: {
      required: true
    },
    service_id: {
      required: true
    },
    status: {
      required: true
    }
  },
  components: {
    mainModal,
    deleteModal
  },
  data() {
    return {
      form: {
        description: "",
        contact: {
          last_name: "",
          first_name: "",
          phome: "",
          email: ""
        },
        date: null,
        time: null
      },

      isValidPhone: false,
      availableDays: [],
      timeOptions: {
        current: null,
        data: null
      },
      isSubmitted: false,
      showDeleteModal: false
    };
  },
  computed: {
    ...mapGetters({
      client: "client/client"
    }),
    pickerOptions() {
      return {
        firstDayOfWeek: 1,
        disabledDate: time => {
          const hasMatch = this.availableDays.find(item => {
            item = new Date(item);
            item.setHours(0, 0, 0, 0);
            return item.getTime() === time.getTime();
          });

          if (!hasMatch) {
            return true;
          }
        }
      };
    },
    isValid() {
      return !this.$v.$invalid && this.isValidPhone;
    },
    canCancel() {
      const statuses = ["closed", "rating_review", "payment", "canceled"];

      return statuses.includes(this.status) === false;
    },
    isCanceled() {
      return this.status == "canceled";
    }
  },
  validations: {
    form: {
      date: {
        required
      },
      time: {
        required
      },
      contact: {
        first_name: {
          required
        },
        last_name: {
          required
        },
        email: {
          checkEmail,
          required
        },
        phone: {
          required
        }
      }
    }
  },
  methods: {
    ...mapActions({
      updateContact: "orders/updateContact",
      updateDate: "orders/updateDate",
      update: "orders/update",
      getWorkload: "public/getWorkload"
    }),
    toggleDeleteModal() {
      this.showDeleteModal = !this.showDeleteModal;
    },
    initForm() {
      this.form.contact = { ...this.contact };
      this.form.date = this.date;
      this.form.time = this.form.date.split(" ")[1].substr(0, 5);
    },
    getDate() {
      const time = this.form.time.split(":");

      return moment(this.form.date)
        .set("hours", +time[0])
        .set("minutes", +time[1])
        .format("Y-MM-DD HH:mm");
    },
    async onSave() {
      this.isSubmitted = true;
      setTimeout(() => {
        this.isSubmitted = false;
      }, 1000);
      const response = await this.updateContact({
        form: { ...this.form.contact },
        id: this.id
      });
      const isOkey = response.status === 200;
      if (!isOkey) return;

      const responseDate = await this.updateDate({
        form: { datetime: this.getDate() },
        id: this.id
      });
      const isOkeyDate = responseDate.status === 200;
      if (!isOkeyDate) return;
      this.$emit("onSave");
    },
    prepareForm() {
      return {
        ...this.form
      };
    },
    checkValue(v) {
      this.isValidPhone = v.valid && v.type == "mobile";
    },
    changeTime(v) {
      const date = moment(v).format("YYYY-MM-DD");
      let isMatch = false;

      this.timeOptions.data.forEach(e => {
        if (e.date == date) {
          this.timeOptions.current = e.slots;
          isMatch = true;
        }
      });

      if (!isMatch) this.timeOptions.current = [];
    },
    async loadWorkload() {
      const res = await this.getWorkload({
        service_id: this.service_id,
        office_id: this.client.office_id
      });

      this.timeOptions.data = res.data.data;
      this.availableDays = this.timeOptions.data.map(item => item.date);

      this.changeTime(this.form.date || new Date());
    },
    getPrice(item) {
      return item.extra_price == "0"
        ? ""
        : `+${item.extra_price}%  ${this.$t("forms.toThePrice")}`;
    },
    async cancel() {
      await this.update({
        form: {
          status: "canceled"
        },
        id: this.id
      });
      this.$log("orderStatus_canceled");
      this.toggleDeleteModal();
      this.$emit("onCanceled");
    }
  },
  created() {
    this.initForm();
    this.loadWorkload();
  }
};
</script>